import { render } from "./CheckoutSchemajson.vue?vue&type=template&id=6da9c39b"
import script from "./CheckoutSchemajson.vue?vue&type=script&lang=js"
export * from "./CheckoutSchemajson.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__